import { useEffect } from 'react';
import { PANES } from '../../../constants/checkoutConstants';
import { setWasNavigatedDueTaxWarningAction } from '../../../actions/checkoutUIActions';
import { setShowTaxWarning } from '../../../actions/checkoutShippingActions';

const useNavigateShippingOnTaxWarning = args => {
    const {
        hasBuyerTaxError,
        wasNavigatedDueTaxWarning,
        onSetWasNavigatedDueTaxWarning,
        onSetShowTaxWarning,
        onNavigateToPane,
        hasShippingAddresses,
        hasCreditCards,
        currentPane,
        isComputing,
        dispatch,
    } = args;
    useEffect(() => {
        if (
            !isComputing &&
            !wasNavigatedDueTaxWarning &&
            currentPane !== PANES.PANE_SHIPPING &&
            hasBuyerTaxError
        ) {
            dispatch(setWasNavigatedDueTaxWarningAction(true));
            dispatch(setShowTaxWarning(true));
            onNavigateToPane({
                pane: PANES.PANE_SHIPPING,
                hasShippingAddresses,
                hasCreditCards,
                currentPane,
                isComputing,
                hasBuyerTaxError,
                dispatch,
            });
        }
    }, [
        hasBuyerTaxError,
        wasNavigatedDueTaxWarning,
        onSetWasNavigatedDueTaxWarning,
        onSetShowTaxWarning,
        onNavigateToPane,
        hasShippingAddresses,
        hasCreditCards,
        currentPane,
        isComputing,
        dispatch,
    ]);
};

export { useNavigateShippingOnTaxWarning };
